import { Box, Button, Section, Stack, Typography } from '@cmg/design-system';
import React from 'react';

import { AttestationFormStatus, CertificateType } from '../../../../../graphql';
import { AttestationFormStatusDisplayName } from '../../../../order-book/attestation/Attestation.model';
import { getAttestationStatus } from '../../compliance/context/hooks/certificates/Certificates.model';
import {
  Attestation,
  ComplianceWarning,
} from '../../compliance/context/hooks/certificates/useCertificatesModel';

export type Props = Readonly<{
  complianceWarning: ComplianceWarning;
  indicationExists: boolean;
  loading: boolean;
  attestation?: Attestation | null;
  certificateType: CertificateType | null;
}>;

const IndicationComplianceWarningWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  complianceWarning,
  indicationExists,
  loading,
  attestation,
  certificateType,
}) => {
  const { hasComplianceWarning, canByPassComplianceWarning, message } = complianceWarning;
  const [skipComplianceWarning, setSkipComplianceWarning] = React.useState<boolean>(false);

  const shouldDisplayComplianceWarning =
    hasComplianceWarning && !indicationExists && !skipComplianceWarning;

  const attestationStatus =
    getAttestationStatus(attestation ?? null) ?? AttestationFormStatus.NotOnFile;
  const shouldDisplayQibStatusTitle =
    certificateType === CertificateType.Qib && canByPassComplianceWarning;

  return (
    <div>
      {shouldDisplayComplianceWarning && (
        <Stack>
          <Section
            data-testid="compliance-warning-view"
            title="Indication"
            actions={
              canByPassComplianceWarning
                ? [
                    <Button
                      key="submit"
                      variant="outlined"
                      data-testid="skip-compliance-warning-button"
                      onClick={() => setSkipComplianceWarning(true)}
                    >
                      Continue to Submit Indication
                    </Button>,
                  ]
                : []
            }
          />

          <Box mt={1} textAlign="center">
            <Typography variant="h3" mb={1} color="text.primary">
              {shouldDisplayQibStatusTitle
                ? `QIB ${AttestationFormStatusDisplayName[attestationStatus]}`
                : 'Compliance Action Required'}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 350 }} mx="auto">
              {message}
            </Typography>
          </Box>
        </Stack>
      )}
      {(indicationExists || !shouldDisplayComplianceWarning) && !loading && children}
    </div>
  );
};

export default IndicationComplianceWarningWrapper;
